export default __webpack_public_path__ + "ab77b045027c2a8bd6978714038132fe.png";